var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-143.000000, -61.000000)",
    stroke: "#B7844D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selector-/-Search",
    transform: "translate(143.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 16.1,
    height: 16.1,
    rx: 8.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.4342857,
    y1: 21.4342857,
    x2: 14.6457143,
    y2: 14.6457143,
    id: "Line-3",
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.704edb7a0856659833d7568f0b2cf9df.svg";
export { ForwardRef as ReactComponent };